<template lang='pug'>
.address-container
    userCard
    van-form(:form='form', layout='vertical', @submit='confirm')
        van-field(
            label='姓名',
            placeholder='收件人姓名',
            name='name',
            :rules='[{ required: true, message: "请输入姓名" }]',
            v-model='form.name'
        )
        van-field(
            label='手机',
            placeholder='收件人手机',
            type='number',
            name='phone',
            :rules='[{ validator, message: "请输入正确手机号" }]',
            v-model='form.phone'
        )
        van-field(
            label='省市区',
            readonly,
            clickable,
            :value='addressText',
            @click='showAddressPicker',
            placeholder='省市区'
        )
        van-popup(v-model='showPicker', position='bottom')
            van-picker(
                ref='addressPicker',
                show-toolbar,
                :columns='addressOptions',
                @cancel='showPicker = false',
                @confirm='onAddressConfirm'
            )
        van-field(
            label='详细地址',
            placeholder='精确到门牌号',
            :rules='[{ required: true, message: "请输入详细地址" }]',
            v-model='form.address.details'
        )
        van-cell(center, title='设为默认地址', label='每次收获会默认使用默认地址')
            template(#right-icon)
                van-switch(v-model='form.isDefault', size='24')
        .button-wrapper
            van-button(type='info', native-type='submit', block, round) 保存
            van-button(type='danger', native-type='button' block, round, @click='deleteRecipient') 删除
</template>

<script>
import userCard from './components/userCard'
import { setStorage, getStorage } from '@/utils/localstorage.js'
import { getAddress, updateRecipient, getRecipient, deleteRecipient } from '@/service/member'
import { ADDRESS_LIST } from '@/configs/constants'
import { mapState } from 'vuex'
export default {
    name: 'addressListAdd',
    data() {
        return {
            form: {
                address: {
                    details: '',
                    province: '北京市',
                    city: '北京市',
                    district: '东城区'
                },
                name: '',
                phone: '',
                isDefault: false
            },
            addressOptions: [],
            showPicker: false,
        }
    },
    components: {
        userCard
    },
    watch: {
        memberInfo: {
            // 预填充
            handler(v) {
                if (v.id) {
                    this.$nextTick(() => {
                        Object.assign(this.form, {
                            phone: v.phone,
                            name: v.personName && v.personName.fullName,
                            // address: v.address
                        })
                        for (let k in v.address) {
                            if (v.address[k]) {
                                this.form.address[k] = v.address[k]
                            }
                        }
                    })
                }
            },
            immediate: true
        }
    },
    async created() {
        this.$root.$emit('action', { name: this.$route.name })
        this.addressOptions = await this.getAddressOptions()
        this.initFomm()
    },

    computed: {
        ...mapState(['memberInfo']),
        addressText() {
            if (this.form.address.province) {
                const { province, city, district } = this.form.address
                return province + ' ' + city + ' ' + district
            }
            return ''
        },
    },
    methods: {
        validator(v) {
            return /^1[345789]\d{9}$/.test(v)
        },
        showAddressPicker() {
            this.showPicker = true
            this.$nextTick(() => {
                const { province, city, district } = this.form.address
                this.$refs.addressPicker.setValues([province, city, district])
            })
        },
        onAddressConfirm(value) {
            Object.assign(this.form.address, this.processAddress(value))
            this.showPicker = false
        },
        processAddress(addressArr) {
            let ks = ['province', 'city', 'district']
            let address = {}
            ks.forEach((k, i) => {
                address[k] = addressArr[i] || ''
            })
            return address
        },
        deleteRecipient() {
            this.$confirm({
                title: '温馨提示',
                message: '确认删除此项收货信息吗',
            }).then(async () => {
                try {
                    await deleteRecipient(this.$route.params.id)
                    this.$message.success('删除成功')
                    this.$router.push({ name: 'address' })
                } catch (error) {
                    this.$message.fail(error.message)
                }
            })
        },
        async confirm() {
            try {
                await updateRecipient(this.form, this.$route.params.id)
                // await updateMember({ ...values, personName: { fullName: values.name } })
                this.$message.success('保存成功')
                this.$router.push({ name: 'address' })
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        value2label(data) {
            for (let item of data) {
                item.text = item.label
                if (item.children) {
                    this.value2label(item.children)
                }
            }
            return data
        },
        async getAddressOptions() {
            // 获取全部省市
            let address = getStorage(ADDRESS_LIST)
            if (!(Array.isArray(address) && address.length > 0)) {
                address = await getAddress()
                setStorage(ADDRESS_LIST, address)
            }
            const addressOptions = this.value2label(address)
            return addressOptions
        },
        async initFomm() {
            const { id } = this.$route.params
            if (id) {
                // 绑定表单域
                this.form = await getRecipient(id)

            }
        }
    }
}
</script>

<style scoped lang='less'>
/deep/.van-cell {
    padding-left: 1rem;
    padding-right: 1rem;
}
/deep/.van-cell::after {
    left: 1rem;
    right: 1rem;
}
.button-wrapper {
    padding: 1rem;
    button {
        margin-top: 1rem;
    }
}
</style>